import { put, call } from 'redux-saga/effects';
import { feedbackCreateAPI, feedbackSearchAPI, feedbackUpdateAPI } from 'src/api/FeedbackApi';
import { SEARCH_RECORD_PAGE_LIMIT } from 'src/constants/CommonConstants';
import { headerShowAction } from 'src/containers/header-container/actions/HeaderActions';
import { takeFirstSagaUtil } from 'src/utils/ReduxSagaUtils';
import { buildSearchWithNoCase } from 'src/utils/CommonUtils';
import { FEEDBACK_ACTIONS } from '../actions/FeedbackActions';
import { toast } from 'react-toastify';

function* search({
    where, currentPage = 0, autopopulate = true, fullTextSearch = true,
} = {}) {
    try {
        const {
            data: {
                data,
            },
        } = yield call(feedbackSearchAPI, {
            where,
            pageLength: SEARCH_RECORD_PAGE_LIMIT,
            currentPage,
            autopopulate,
        });

        yield put({
            type: FEEDBACK_ACTIONS.FEEDBACK_SEARCH_SUCCESS,
            data,
        });

        return data;
    }
    catch (error) {
        console.error('LOG: function*search -> error', error);
        yield put({
            type: FEEDBACK_ACTIONS.FEEDBACK_SEARCH_ERROR,
        });
        return null;
    }
}

function* edit({
    _id,
}) {
    try {
        const {
            data: {
                data: {
                    data,
                },
            },
        } = yield call(feedbackSearchAPI, {
            where: {
                _id,
            },
            autopopulate: false,
        });

        if (!data || !data[0]) {

            yield put(headerShowAction({
                data: 'Unable to Edit, something when wrong',
            }));
        }
        delete data[0].password;

        yield put({
            type: FEEDBACK_ACTIONS.FEEDBACK_UPSERT_SUCCESS,
            currentRecord: data[0],
            data: data[0],
        });
    }
    catch (error) {
        console.error('LOG: error', error);

        yield put(headerShowAction({
            data: error.response.data.data,
        }));

        yield put(headerShowAction({
            data: error.response.data.data,
        }));
    }
}

function* insert(payload) {
    try {
        const {
            data: {
                data,
            },
        } = yield call(feedbackCreateAPI, payload);
        if (data?._id && payload.profilePicture) {
            // yield call(feedbackProfilePicAPI, {
            //     feedbackId: data?._id,
            //     data: payload,
            // });
        }


        yield put(headerShowAction({
            data: 'Created',
        }));
        toast("feedback Created")

        yield put({
            type: FEEDBACK_ACTIONS.FEEDBACK_UPSERT_SUCCESS,
            data: {
                ...payload,
                _id: data?._id,
            },
        });
        yield put({
            type: FEEDBACK_ACTIONS.FEEDBACK_RESET
        });
        yield put({
            type: FEEDBACK_ACTIONS.FEEDBACK_SEARCH
        });
    }
    catch (error) {
        toast.error(error?.message);
        toast.error(error?.response?.data?.message);
        yield put({
            type: FEEDBACK_ACTIONS.FEEDBACK_UPSERT_ERROR,
        });
    }
}

function* bulkUpload(payload) {
    try {






        // const { finalData } = yield call(feedbackUploadAPI, payload);

        // toast(`${finalData.length} feedback uploaded successfully`)

        yield put({
            type: FEEDBACK_ACTIONS.FEEDBACK_UPLOAD_SUCCESS,
            data: {
                ...payload,

            },
        });
        yield put({
            type: FEEDBACK_ACTIONS.FEEDBACK_SEARCH
        });
    }
    catch (error) {
        console.error('LOG: upsert error', error);
        yield put(headerShowAction({
            data: error.response.data.data,
        }));

        yield put({
            type: FEEDBACK_ACTIONS.FEEDBACK_UPLOAD_ERROR,
        });
    }
}

function* update(feedbackId, payload) {
    try {
        yield call(feedbackUpdateAPI, {
            feedbackId,
            data: payload,
        });

        yield put(headerShowAction({
            data: 'Updated',
        }));
        if (payload.deleted === true) {
            toast("feedback deleted")
        }
        else {
            toast("feedback account updated")
        }

        yield put({
            type: FEEDBACK_ACTIONS.FEEDBACK_SEARCH
        });
    }
    catch (error) {
        console.error('LOG: upsert error', error);
        yield put(headerShowAction({
            data: error.response.data.data,
        }));

        yield put({
            type: FEEDBACK_ACTIONS.FEEDBACK_UPSERT_ERROR,
        });
    }
}

function* upsert({
    _id,
    ...payload
}) {
    if (_id) {
        yield update(_id, payload);
    }
    else {
        yield insert(payload);
    }
}

export default [
    takeFirstSagaUtil(FEEDBACK_ACTIONS.FEEDBACK_SEARCH, search),
    takeFirstSagaUtil(FEEDBACK_ACTIONS.FEEDBACK_UPSERT, upsert),
    takeFirstSagaUtil(FEEDBACK_ACTIONS.FEEDBACK_UPLOAD, bulkUpload),
    takeFirstSagaUtil(FEEDBACK_ACTIONS.FEEDBACK_EDIT, edit),
];
